import React from 'react';


export interface PuzzleHeaderProps {
  puzzleId: string;  
  onOpenHelp: () => void;
  numbersCount: number;
  onNumbersCountChange: (count: number) => void;
}

const PuzzleHeader: React.FC<PuzzleHeaderProps> = ({
  puzzleId,
  onOpenHelp,
  numbersCount,
  onNumbersCountChange,
}) => {
  // const [timeLeft, setTimeLeft] = useState<number>(900);
  // useEffect(()=>{setTimeLeft(900)},[puzzleId])

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft(prevTime => {
  //       if (prevTime <= 0) {
  //         clearInterval(timer);
  //         return 0;
  //       }
  //       return prevTime - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  return (
    <header className="header">
      <div className="numbers-selector">
        {/* {[4, 5, 6].map((num) => (
          <button
            key={num}
            className={`selector-button ${num === numbersCount ? 'active' : ''}`}
            onClick={() => onNumbersCountChange(num)}
          >
            {num}
          </button>
        ))} */}
      </div>
      
      <button className="help-button" onClick={onOpenHelp}>
        How to Play
      </button>
    </header>
  );
};

export default PuzzleHeader;
